module.exports = __webpack_public_path__ + "media/images/responsive/fairs/cv/icon_available_online-8d37527ad2c0e74b8b4ec9dcbb110bbd.svg";